module.exports = __webpack_public_path__ + "img/menu1.9c78c54f.png";